import { companyAPI } from '@/services-ts/axios'
import type { ICreateCompany, IPaging, IUpdateCompany } from '@/types/Request'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useCompanyStore = defineStore('company', {
  actions: {
    async GetAllCompanyList(payload: IPaging) {
      const response = await companyAPI.CompanyServices.GetAllCompanyList(payload)
      return response.status
        ? { data: response.data, total: response.total }
        : { data: [], total: 0 }
    },

    async CreateCompany(payload: ICreateCompany) {
      const { status } = await companyAPI.CompanyServices.CreateCompany(payload)

      if (status) {
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
        await this.GetAllCompanyList({ Skip: 0, Take: 10 })
      }
      return status
    },

    async UpdateCompany(payload: IUpdateCompany) {
      const { status } = await companyAPI.CompanyServices.UpdateCompany(payload)

      if (status) {
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
      return status
    },

    async GetCompanyPublicInfo() {
      const domainIncludes = window.location.origin.includes('empactivo')
      const isLocal = window.location.hostname === 'localhost'
      if (domainIncludes || isLocal) {
        return { data: null, status: false }
      } else {
        const { data, status } = await companyAPI.CompanyServices.GetCompanyPublicInfo(
          window.location.origin,
        )
        return { data, status }
      }
    },

    async DeleteCompanyBanner(Id: string) {
      const { status } = await companyAPI.CompanyServices.DeleteCompanyBanner(Id)

      if (status) {
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
    },

    async DeleteCompanyBackground(Id: string) {
      const { status } = await companyAPI.CompanyServices.DeleteCompanyBackground(Id)

      if (status) {
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
    },

    async DeleteInactiveImage(Id: string) {
      const { status } = await companyAPI.CompanyServices.DeleteInactiveImage(Id)

      if (status) {
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
    },

    async DeletePushLogoImage(Id: string) {
      const { status } = await companyAPI.CompanyServices.DeletePushLogoImage(Id)

      if (status) {
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
    },

    async DeleteFourWeekImage(Id: string) {
      const { status } = await companyAPI.CompanyServices.DeleteFourWeekImage(Id)

      if (status) {
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
    },

    async GetCompanyIdentityProviderList(CompanyCode: string) {
      const { status, data } =
        await companyAPI.CompanyServices.GetCompanyIdentityProviderList(CompanyCode)
      if (status && Array.isArray(data) && data.length > 0) {
        return data
      } else {
        return []
      }
    },
  },
})
